// SavingsPotsConstants.js
import keyMirror from 'keymirror';

export default keyMirror({
  REQUEST_POT_ACCOUNTS_LIST: null,
  REQUEST_POT_ACCOUNTS_LIST_SUCCESS: null,
  REQUEST_POT_ACCOUNTS_LIST_ERROR: null,
  REQUEST_POT_DATA: null,
  REQUEST_POT_DATA_SUCCESS: null,
  REQUEST_POT_DATA_ERROR: null,
  REQUEST_SINGLE_POT_DATA_SUCCESS: null,
  REQUEST_SELECTED_ACCOUNT: null,
  REQUEST_CREATE_PAGE: null,
  REQUEST_POT_DETAIL_PAGE: null,
  REQUEST_REDUCE_POT_PAGE: null,
  REQUEST_NEW_POT_CONFIRMATION: null,
  REQUEST_DELETE_POT_CONNECTION: null,
  REQUEST_DELETE_POT_CONNECTION_SUCCESS: null,
  REQUEST_EDITED_POT_DATA: null,
  REQUEST_INTERPOT_DATA: null,
  REQUEST_CREATED_POT_DATA_SUCCESS: null,
  SPENDING_MOVE_MONEY: null,
  SPENDING_TRANSFER_MONEY: null,
  REQUEST_INTERPOT_DATA_SUCCESS: null,
  REQUEST_CREATED_POT_DATA_ERROR: null,
  REQUEST_SINGLE_POT_DATA_ERROR: null,
  REQUEST_INTERPOT_DATA_ERROR: null,
  REQUEST_CLOSE_ERROR_MODAL: null,
  REQUEST_POT_DETAIL_DATA_ERROR: null,
  REQUEST_POT_DATA_REJIG_SUCCESS: null,

  POT_NAVIGATION_REFERENCE: null,
  REQUEST_POT_DATA_SUCCESS_MOVEMONEY: null,
});
